<template>
  <div v-if="isReady">
    <vue-apex-charts
      type="donut"
      height="450"
      width="450"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts
  },
 
  props: {
    series: {
      type: Array,
      default () {
        return []
      }
    },
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    chartOptions: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      isReady: false
    }
  },

  mounted () {
    this.isReady = true
  }
}
</script>

